export interface Testimonial {
  id: number;
  name: string;
  location: string;
  image: string;
  rating: number;
  destination: string;
  feedback: string;
  tripType: string;
}

// Import customer images (using existing assets as placeholders)
import customer1 from "@/assets/team-member-1.jpg";
import customer2 from "@/assets/team-member-2.jpg";
import customer3 from "@/assets/team-member-3.jpg";
import customerKiran from "@/assets/customer-kiran.jpg";
import customerSharma from "@/assets/customer-sharma.jpg";
import customerJoshi from "@/assets/customer-joshi.jpg";

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Priya & Raj Mehta",
    location: "Mumbai, Maharashtra",
    image: customer1,
    rating: 5,
    destination: "Maldives Honeymoon",
    feedback: "Our Maldives honeymoon was absolutely magical! Feel Free Holidays took care of every detail - from overwater villa to candlelight dinners. The customized itinerary was perfect for us. Highly recommended for honeymooners!",
    tripType: "Honeymoon"
  },
  {
    id: 2,
    name: "Amit Shah Family",
    location: "Surat, Gujarat",
    image: customer2,
    rating: 5,
    destination: "Kashmir Paradise",
    feedback: "We had an incredible family vacation in Kashmir! The Dal Lake Shikara ride, Gulmarg cable car, and snow activities were highlights. FFH's planning made it stress-free. Our kids still talk about it!",
    tripType: "Family Trip"
  },
  {
    id: 3,
    name: "Neha & Rohan Patel",
    location: "Ahmedabad, Gujarat",
    image: customer3,
    rating: 5,
    destination: "Bali Honeymoon",
    feedback: "Bali was a dream come true! Feel Free Holidays arranged everything perfectly - from romantic dinners to temple tours. The private villa was stunning. Thank you for making our honeymoon unforgettable!",
    tripType: "Honeymoon"
  },
  {
    id: 4,
    name: "Kiran Desai",
    location: "Vadodara, Gujarat",
    image: customerKiran,
    rating: 5,
    destination: "Dubai Luxury Tour",
    feedback: "Dubai trip exceeded all expectations! Burj Khalifa, desert safari, shopping - everything was well organized. The team was responsive and helpful throughout. Will definitely book again!",
    tripType: "Leisure"
  },
  {
    id: 5,
    name: "Sharma Family",
    location: "Rajkot, Gujarat",
    image: customerSharma,
    rating: 5,
    destination: "Kerala Backwaters",
    feedback: "Kerala houseboat experience was serene and beautiful! Munnar tea gardens, Alleppey backwaters, Thekkady safari - all perfectly planned. FFH made our family vacation memorable. Excellent service!",
    tripType: "Family Trip"
  },
  {
    id: 6,
    name: "Deepak & Anjali Joshi",
    location: "Navsari, Gujarat",
    image: customerJoshi,
    rating: 5,
    destination: "Switzerland & Paris",
    feedback: "Our Europe honeymoon was spectacular! Switzerland's Alps and Paris's romance - perfectly balanced itinerary. The Swiss trains and Eiffel Tower dinner were unforgettable. Thank you FFH team!",
    tripType: "Honeymoon"
  },
  {
    id: 7,
    name: "Mehul Thakkar",
    location: "Surat, Gujarat",
    image: customer2,
    rating: 5,
    destination: "Thailand Package",
    feedback: "Bangkok and Phuket tour was fantastic! Coral Island, Grand Palace, Thai massage - everything was amazing. Great value for money and excellent arrangements. Highly recommend FFH!",
    tripType: "Group Tour"
  },
  {
    id: 8,
    name: "Patel Family",
    location: "Bharuch, Gujarat",
    image: customer3,
    rating: 5,
    destination: "Rajasthan Heritage",
    feedback: "Rajasthan's palaces and forts were breathtaking! Jaipur, Udaipur, Jodhpur - each city was magical. The heritage hotels and desert safari were highlights. FFH made it seamless!",
    tripType: "Family Trip"
  }
];
